module.exports = __webpack_public_path__ + "img/course-16.14366bda.png";